import { render, staticRenderFns } from "./ExperienciasProfissionais.vue?vue&type=template&id=bcaa0ada&"
import script from "./ExperienciasProfissionais.vue?vue&type=script&lang=js&"
export * from "./ExperienciasProfissionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports